import { colors } from "../colors_v2.js";
import { utilsApp } from "../utils-app_v2.js";
import { identityService } from "./identityService_v2.js";
import { profile } from "./profile_v2.js";
import { eventHub } from "../eventHub_v2.js";
import { iPop } from "../ipop_v2.js";
import { router } from "../router_v2.js";

const renderCreateAccountPop = (joinCode) => {
  const createAccountSection = document.getElementById("createAccountSection");
  const modalBehinder = document.getElementById("modalBehinder");
  modalBehinder.dataset.action = "modalBehinderCloseCreateAccountPop";
  modalBehinder.style.display = "block";
  const html = `
  <div class="popUpHead">Create Account</div>
  <form id="createAccountForm">
    <div class="labelForInput">
      <label class="left marginTop10" for="crtEmail">Email:
        <input 
          id="crtEmail" 
          class="inputFP" 
          type="email" 
          autocomplete="username email" 
          placeholder="Please enter your email"></input>
        <div class="inputMessages" id="crtEmailMsg"></div>
      </label>
    </div>
    <div class="labelForInput">
      <label class="left marginTop10" for="crtPassword">Password:
        <input 
          id="crtPassword" 
          class="inputFP" 
          autocomplete="new-password" 
          type="password" 
          placeholder="Must be at least 8 characters"></input>
        <div class="inputMessages" id="crtPasswordMsg"></div>
      </label>
    </div>
    <div class="labelForInput">
      <label class="left marginTop10" for="crtName">Name:
        <input 
          id="crtName" 
          class="inputFP" 
          autocomplete="off" 
          type="text" 
          placeholder="How would you like to be known?"></input>
        <div class="inputMessages" id="crtNameMsg"></div>
      </label>
    </div>
    <br>
    <br>
    <div id="optional">Optional:</div>
    <hr>
    <div class="labelForInput">
      <label class="left marginTop10" for="crtBlurb">Blurb:<div id="blurbSplainer" class="i">ⓘ</div>
        <input 
          id="crtBlurb" 
          class="inputFP" 
          autocomplete="off" 
          type="text" 
          placeholder="Optional..."></input>
        <div class="inputMessages" id="crtBlurbMsg"></div>
      </label>
    </div>
    <div class="labelForInput">
        <input id="iAmRil" autocomplete="off" type="checkbox"></input>
        <label class="left marginTop10" for="iAmRil"> I am ril<div id="rilSplainer" class="i">ⓘ</div>
        <div class="inputMessages" id="iAmRilMsg"> </div>
      </label>
    </div>
    <div class="labelForInput">
      <label class="left marginTop10" for="secQ">Security Question:<div id="secQSplainer" class="i">ⓘ</div>
        <input id="secQ" class="inputFP" autocomplete="off" placeholder="e.g. Food I Hate"></input>
        <div class="inputMessages" id="secQMsg"></div>
      </label>
    </div>
    <div class="labelForInput">
      <label class="left marginTop10" for="secA" >Security Answer:
        <input id="secA" class="inputFP" autocomplete="off" placeholder="e.g. Tomatoes"></input>
        <div class="inputMessages" id="secAMsg"></div>
      </label>
    </div>
      <div id="crtButtons">
        <button id="crtSubmitButton" class="submitButton button workADayButtons">Submit</button>
      </div>
       <div class="inputMessages" id="submitMsg"></div>
    </form>
    <div id="createAccountX" class = "x"></div>
  `;
  createAccountSection.innerHTML = html;

  const crtPassword = document.getElementById("crtPassword");
  crtPassword.style.backgroundColor = colors.getGameColor("lighterAccent");

  const crtName = document.getElementById("crtName");
  crtName.style.backgroundColor = colors.getGameColor("lighterAccent");

  const crtBlurb = document.getElementById("crtBlurb");
  crtBlurb.style.backgroundColor = colors.getGameColor("lighterAccent");

  const secQ = document.getElementById("secQ");
  secQ.style.backgroundColor = colors.getGameColor("lighterAccent");

  const secA = document.getElementById("secA");
  secA.style.backgroundColor = colors.getGameColor("lighterAccent");

  const iAmRil = document.getElementById("iAmRil");
  iAmRil.style.backgroundColor = colors.getGameColor("lighterAccent");

  createAccountSection.style.backgroundImage =
    "radial-gradient(circle, " +
    colors.getGameColor("lighterAccent") +
    ", " +
    colors.getGameColor("lightAccent");
  createAccountSection.classList.remove("hide");
  colors.setButtonColors();
  const crtEmail = document.getElementById("crtEmail");
  crtEmail.style.backgroundColor = colors.getGameColor("lighterAccent");
  crtEmail.focus();
};

const renderSecQSplainer = (event) => {
  iPop.render({
    text: "Lets you recover your account if you forget your password",
    event,
  });
};

const renderRilSplainer = (event) => {
  iPop.render({
    text: "Only check this if you are, in fact, ril. <br><br>(Placeholder for future Google captcha)",
    event,
  });
};

const renderBlurbSplainer = (event) => {
  iPop.render({
    text: "Blurbs help other people identify you",
    event,
  });
};

const handleSubmit = async (event) => {
  const submitButton = document.getElementById("crtSubmitButton");
  submitButton.disabled = true;
  const submitMsg = document.getElementById("submitMsg");
  submitMsg.innerText = "Submitting... ";
  document.body.style.cursor = "wait";
  submitButton.style.cursor = "wait";
  const name = document.getElementById("crtName").value.trim();
  const email = document.getElementById("crtEmail").value.trim();
  // Not trimmed: log on, change and reset don't trim either, so the password
  // has to be exactly what was typed.
  const password = document.getElementById("crtPassword").value;
  const blurb = document.getElementById("crtBlurb").value.trim();

  if (identityService.isNameValid(name).status != 200) {
    document.body.style.cursor = "default";
    submitMsg.innerText = "Please correct your name";
    submitButton.disabled = false;
    return;
  }

  if (blurb.length > 0) {
    // its optional, but if you enter something, we gotta check it
    if (identityService.isBlurbValid(blurb).status != 200) {
      submitMsg.innerText = "Please correct your blurb";
      submitButton.disabled = false;
      document.body.style.cursor = "default";
      submitButton.style.cursor = "default";
      return;
    }
  }

  if (identityService.isEmailValid(email).status != 200) {
    submitMsg.innerText = "Please correct your email";
    submitButton.disabled = false;
    document.body.style.cursor = "default";
    submitButton.style.cursor = "default";
    return;
  }

  if (identityService.isPasswordValid(password).status != 200) {
    submitMsg.innerText = "Please correct your password";
    submitButton.disabled = false;
    document.body.style.cursor = "default";
    submitButton.style.cursor = "default";
    return;
  }

  if (email.length === 0) {
    submitMsg.innerText = "Please enter your email";
    submitButton.disabled = false;
    document.body.style.cursor = "default";
    submitButton.style.cursor = "default";
    return;
  }
  if (password.length === 0) {
    submitMsg.innerText = "Please enter a password";
    submitButton.disabled = false;
    document.body.style.cursor = "default";
    submitButton.style.cursor = "default";
    return;
  }
  if (name.length === 0) {
    submitMsg.innerText = "Please enter your name";
    submitButton.disabled = false;
    document.body.style.cursor = "default";
    submitButton.style.cursor = "default";
    return;
  }

  // don't need all attributes here, just those unique to a new account
  const identity = {
    name: name,
    email: email,
    password: password,
    amIRil: document.getElementById("iAmRil").checked,
    type: "account",
  };
  const secQ = document.getElementById("secQ").value.trim();
  if (secQ.length > 2) {
    identity.secQ = secQ;
  }
  const secA = document.getElementById("secA").value.trim();
  if (secA.length > 2) {
    identity.secA = secA;
  }
  if (blurb.length > 2) {
    identity.blurb = blurb;
  }

  const result = await identityService.createIdentity(identity); // does not set playing as
  document.body.style.cursor = "default";
  submitButton.style.cursor = "default";

  if (result.status != 200) {
    submitMsg.innerText = "Account not created: " + result.message;
    submitButton.disabled = false;
    return;
  }
  // account is created, so...
  await identityService.setPlayingAs({
    name: result.identity.name,
    createMatch: false,
  });

  if (result.status === 200) {
    closeCreateAccountPop();
    utilsApp.makeNavsSmall();
    profile.render("normal");
    const urlJoinCode = router.getURLJoinCode();
    if (urlJoinCode.length > 0) {
      const joinResult = await join.joinByURL(urlJoinCode);
    }
  }
};

const closeCreateAccountPop = () => {
  document.getElementById("createAccountSection").innerHTML = "";
  document.getElementById("createAccountSection").classList.add("hide");
  const modalBehinder = document.getElementById("modalBehinder");
  modalBehinder.style.display = "none";
  delete modalBehinder.dataset.action;
};

const handleEmailKeyUp = (event) => {
  const email = document.getElementById("crtEmail").value;
  const messageElement = document.getElementById("crtEmailMsg");
  const result = identityService.isEmailValid(email);
  if (result.status != 200) {
    messageElement.innerText = result.message;
    return;
  }
  // if they got through all that, then
  messageElement.innerText = "";
};

const handlePasswordKeyUp = (event) => {
  const password = document.getElementById("crtPassword").value;
  const messageElement = document.getElementById("crtPasswordMsg");
  const result = identityService.isPasswordValid(password);
  if (result.status != 200) {
    messageElement.innerText = result.message;
    return;
  }
  // if they got through all that, then
  messageElement.innerText = "";
};

const handleNameKeyUp = (event) => {
  // event.stopPropagation();
  const text = document.getElementById("crtName").value;
  const messageElement = document.getElementById("crtNameMsg");
  const result = identityService.isNameValid(text);
  if (result.status != 200) {
    messageElement.innerText = result.message;
    return;
  }
  // if they got through all that, then
  messageElement.innerText = "";
};

const handleCrtBlurbKeyUp = (event) => {
  const text = document.getElementById("crtBlurb").value;
  const messageElement = document.getElementById("crtBlurbMsg");
  const result = identityService.isBlurbValid(text);
  if (result.status != 200) {
    messageElement.innerText = result.message;
    return;
  }
  // if they got through all that, then
  messageElement.innerText = "";
};

const handleSecQKeyUp = (event) => {
  const text = document.getElementById("secQ").value;
  const messageElement = document.getElementById("secQMsg");
  const result = identityService.isSecQAValid(text);
  if (result.status != 200) {
    messageElement.innerText = result.message;
    return;
  }
  // if they got through all that, then
  messageElement.innerText = "";
};

const handleSecAKeyUp = () => {
  const text = document.getElementById("secA").value;
  const messageElement = document.getElementById("secAMsg");
  const result = identityService.isSecQAValid(text);
  if (result.status != 200) {
    messageElement.innerText = result.message;
    return;
  }
  // if they got through all that, then
  messageElement.innerText = "";
};

eventHub.registerEvent(
  "click",
  "modalBehinderCloseCreateAccountPop",
  closeCreateAccountPop,
);
eventHub.registerEvent("keyup", "crtEmail", handleEmailKeyUp);
eventHub.registerEvent("keyup", "crtPassword", handlePasswordKeyUp);
eventHub.registerEvent("keyup", "crtName", handleNameKeyUp);
eventHub.registerEvent("keyup", "crtBlurb", handleCrtBlurbKeyUp);
eventHub.registerEvent("keyup", "secQ", handleSecQKeyUp);
eventHub.registerEvent("keyup", "secA", handleSecAKeyUp);
eventHub.registerEvent("submit", "createAccountForm", handleSubmit);
eventHub.registerEvent("click", "createAccountX", closeCreateAccountPop);
eventHub.registerEvent("click", "secQSplainer", renderSecQSplainer);
eventHub.registerEvent("click", "rilSplainer", renderRilSplainer);
eventHub.registerEvent("click", "blurbSplainer", renderBlurbSplainer);

export const createAccount = {
  render: renderCreateAccountPop,
};
